import { create } from "zustand";

export type AppToastVariant = "success" | "error" | "info";

export type AppToastItem = {
  id: number;
  variant: AppToastVariant;
  message: string;
};

type AppToastState = {
  toast: AppToastItem | null;
  show: (variant: AppToastVariant, message: string) => void;
  dismiss: () => void;
};

// トーストの再マウント判定に使う連番（key 用）
let toastIdCounter = 0;

export const useAppToastStore = create<AppToastState>((set) => ({
  toast: null,
  show: (variant, message) =>
    set({ toast: { id: ++toastIdCounter, variant, message } }),
  dismiss: () => set({ toast: null }),
}));
